import React from 'react';
import { useShipmentContext } from '../../../../components/ShipmentProvider/ShipmentProvider';
import ContactInformation from '@afosto/app-components-react/ContactInformation';

const ShipmentContactSection = () => {
  const { contact, isFetchingContact } = useShipmentContext();
  const { organisations = {} } = contact || {};
  const { primary: organisation } = organisations;

  return (
    <ContactInformation
      contact={contact}
      organisation={organisation}
      isLoading={isFetchingContact}
    />
  );
};

export default ShipmentContactSection;
